import type { TypeToken } from "@codemation/core";
import type { PairingConfig } from "./pairing.types";

export const PairingConfigToken = Symbol.for("codemation.pairing.PairingConfig") as TypeToken<PairingConfig>;
